import { useEffect, useLayoutEffect, useRef } from 'react';
import type { SessionNoteDraft } from '@/api/assistantVoice/assistantVoiceApi.types';
import { useOptionalAssistantUi } from '../uiActions/assistantUiContext';

interface SessionNoteFormHandlers {
  applyDraft: (draft: SessionNoteDraft) => void;
  saveAsDraft: () => Promise<boolean>;
  hasUnsavedChanges: () => boolean;
}

export function useAssistantSessionNoteForm(
  patientId: string,
  handlers: SessionNoteFormHandlers
): void {
  const assistantUi = useOptionalAssistantUi();
  const handlersRef = useRef(handlers);

  useLayoutEffect(function keepLatestHandlers() {
    handlersRef.current = handlers;
  });

  useEffect(
    function registerOpenForm() {
      if (assistantUi === null || patientId === '') {
        return undefined;
      }
      return assistantUi.sessionNoteForms.register({
        patientId,
        applyDraft: function applyLatest(draft) {
          handlersRef.current.applyDraft(draft);
        },
        saveAsDraft: function saveLatest() {
          return handlersRef.current.saveAsDraft();
        },
        hasUnsavedChanges: function readLatestUnsavedChanges() {
          return handlersRef.current.hasUnsavedChanges();
        },
      });
    },
    [assistantUi, patientId]
  );
}
